import React from 'react';
import { FormattedMessage } from 'react-intl';
import { history } from './../../configuration/store';
import ProjectsList from './projectsList';

class ProjectsPage extends React.Component {
    render() {
        return (
            <div className="page">
                <div className="row">
                    <div className="col-xs-12">
                        <h4>{ProjectsPage.meta.label}</h4>
                    </div>
                    <div className="col-xs-12">
                        <ProjectsList />
                    </div>
                </div>
            </div>
        );
    }
}

ProjectsPage.meta = {
    label: <FormattedMessage id={'projects'} defaultMessage={'Projects'} />,
    icon: 'group_work',
    action: () => history.push('/projects'),
    locations: ['/projects']
};

export default ProjectsPage;



// WEBPACK FOOTER //
// ./src/pages/projects/index.jsx